import axios from "axios";

const API_URL_LAB_TESTS =
  "https://revolutionlab-001-site2.dtempurl.com/LabResults/GetLabResults";

const API_URL_IMAGING_TESTS =
  "https://revolutionlab-001-site2.dtempurl.com/ImagingResults/GetImagingResults";

const API_URL_MICROBIOLOGY_TESTS =
  "https://revolutionlab-001-site2.dtempurl.com/Microbiology/GetMicrobiologyResults";

const API_URL_PATHOANATOMY_TESTS =
  "https://revolutionlab-001-site2.dtempurl.com/Patoanatomy/GetPatoAnatomyResults";

// const API_URL_MICROBIOLOGY_TESTS =
//   "http://revolutionlab-001-site16.anytempurl.com/Microbiology/GetMicrobiologyResults";

// const API_URL_PATHOANATOMY_TESTS =
//   "http://revolutionlab-001-site16.anytempurl.com/Patoanatomy/GetPatoAnatomyResults";

export interface LabTestResult {
  labResult: {
    activityID: number;
    agree: string;
    comment: string | null;
    finSourceID: number;
    highLimit: string | null;
    id: number;
    labExamStatus: number;
    labNum: number;
    level: number;
    lowLimit: string | null;
    mUnit: string | null;
    name: string;
    patoStateID: number;
    requestDateTime: Date;
    requestID: number;
    resOrder: number;
    result: string | null;
    sOrder: number;
    serviceID: number;
    serviceTypeID: number;
    serviceTypeName: string;
    serviceTypeOrder: number;
    statusWork: number;
    webUserID: number;
  };
  physistDetails: {
    RequestID: number;
    ExecPhysID: string;
    ExecPhysName: string;
    RequestDateTime: string;
    ReqPhysistID: string;
    ReqPhysistNAme: string;
  };
}

export interface ImagingTestResult {
  imagingResult: {
    id: number;
    service: string;
    text: string;
    date: Date;
    bcRisk: string;
    pH_ID: string;
  };
  physistDetails: {
    ID: number;
    PH_ID: number;
    PhysicianFullName: string;
  };
}

export interface MicrobiologyResult {
  labnum: number;
  labdate: Date;
  wardTypeID: number;
  name: string;
  result: string | null;
  seroResult: string | null;
  microResult: string | null;
  status: number;
}

export interface PathoAnatomyResult {
  labnum: number;
  labdate: Date;
  wardTypeID: number;
  name: string | null;
  result: string | null;
  seroResult: string | null;
  microResult: string | null;
  status: number;
}

// Get lab tests
export const getUserLabTests = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL_LAB_TESTS, config);
  return response.data;
};

// Get imaging tests
export const getUserImagingTests = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL_IMAGING_TESTS, config);
  return response.data;
};

// Get microbiology tests
export const getUserMicrobiologyTests = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL_MICROBIOLOGY_TESTS, config);
  return response.data;
};

// Get pathoanatomy tests
export const getUserPathoanatomyTests = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL_PATHOANATOMY_TESTS, config);
  return response.data;
};
